import {isMobile} from 'is-mobile';
import {isNil, map} from 'lodash';
import {useCallback} from 'react';

import {Dropdown, DropdownItem, DropdownProps, Icon} from 'components';
import {FacingMode} from 'enums';

type Props = {
    videoDevices?: MediaDeviceInfo[];
    dropdownProps?: Partial<DropdownProps>;
    constraints: MediaTrackConstraintSet;
    updateVideoDevice: (params: MediaTrackConstraintSet) => void;
}

export const CameraSwitcher: React.FC<Props> = ({videoDevices, dropdownProps, constraints, updateVideoDevice}: Props) => {
    const updateVideoDeviceById = useCallback((deviceId: string) => {
        if (deviceId !== '') {
            updateVideoDevice({deviceId: {exact: deviceId}});
        }
    }, [updateVideoDevice]);

    const updateVideoDeviceByFacingMode = useCallback((facingMode: FacingMode) => {
        if (!isNil(facingMode)) {
            updateVideoDevice({facingMode: {exact: facingMode}});
        }
    }, [updateVideoDevice]);

    const toggleFacingMode = useCallback(() => {
        if ((constraints?.facingMode as ConstrainDOMStringParameters)?.exact === FacingMode.Environment) {
            updateVideoDeviceByFacingMode(FacingMode.User);
        } else {
            updateVideoDeviceByFacingMode(FacingMode.Environment);
        }
    }, [constraints, updateVideoDeviceByFacingMode]);

    if (videoDevices?.length < 2) {
        return null;
    } else if (isMobile({tablet: true})) {
        return <Icon name='switch-camera' button onClick={toggleFacingMode} />;
    } else {
        return (
            <Dropdown {...dropdownProps} triggerNode={({open}) => <Icon name='switch-camera' button primary={open} />}>
                {map(videoDevices, (device) => (
                    <DropdownItem
                        key={device?.deviceId}
                        selected={constraints?.deviceId === device.deviceId}
                        onClick={() => updateVideoDeviceById(device.deviceId)}
                    >
                        {device.label}
                    </DropdownItem>
                ))}
            </Dropdown>
        );
    }
};
